import { useAPIClient } from '../hooks';
import type { BaseMutationOptions } from './useBaseMutation';
import useBaseMutation from './useBaseMutation';

function useMutation<
  TData = unknown,
  TError = Error,
  TVariables = void,
  TContext = unknown,
>(params: BaseMutationOptions<TData, TError, TVariables, TContext>) {
  const apiClient = useAPIClient();
  return useBaseMutation<TData, TError, TVariables, TContext>(
    apiClient,
    params,
  );
}

export default useMutation;
